import React, { memo } from 'react';
import { SuggestionPillsContainer } from './styled';
import { NLPConversationBubble } from './NLPConversationBubble';

/**
 * Renders a list of clickable suggestion prompts as pills.
 *
 * @param {Object} props
 * @param {Array<string|{id?: string, prompt: string, viewName?: string|null, category?: string|null, sortOrder?: number}>} props.items - Suggestions to display.
 * @param {(item: {id?: string, prompt: string, viewName?: string|null, category?: string|null, sortOrder?: number}) => void} props.onSelect - Called with the selected suggestion.
 * @param {boolean} [props.disabled] - Disables all pills when true.
 * @param {(item: {id?: string, prompt: string, viewName?: string|null, category?: string|null, sortOrder?: number}) => string|null|undefined} [props.getIcon] - Optional icon resolver for each suggestion.
 */
export const SuggestionList = memo(props => {
  if (!props.items || props.items.length === 0) return null;

  const normalizedItems = props.items
    .map((item, index) => {
      if (typeof item === 'string') {
        return {
          id: `legacy-${index}`,
          prompt: item,
          viewName: null,
          category: null,
          sortOrder: index,
        };
      }

      if (!item || typeof item !== 'object' || !item.prompt) {
        return null;
      }

      return item;
    })
    .filter(Boolean);

  return (
    <SuggestionPillsContainer>
      {normalizedItems.map((item, idx) => (
        <NLPConversationBubble
          key={item.id || `${item.prompt}-${idx}`}
          suggestion
          onClick={() => props.onSelect(item)}
          disabled={props.disabled}
          icon={props.getIcon ? props.getIcon(item) : null}
          testId={`nlp-suggestion-${item.prompt}`}
        >
          {item.prompt}
        </NLPConversationBubble>
      ))}
    </SuggestionPillsContainer>
  );
});
